import { lazy, ComponentType } from 'react'
import { recoverFromDeploymentError } from './deploymentRecovery'

export function lazyWithRetry<T extends ComponentType<unknown>>(
  importFn: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      return await importFn()
    } catch (error) {
      if (recoverFromDeploymentError(error)) {
        // Keep React Suspense mounted while the cache-busted navigation starts.
        // Throwing here would replace the page with an error/blank state first.
        return await new Promise<{ default: T }>(() => {})
      }
      throw error
    }
  })
}
